import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from './../layouts/dashboard';
import { RoutesList } from '../../components/Routes/RoutesList';

export const RoutesPage = () => {
  return (
    <DashboardLayout title={'Rutas'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <RoutesList />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
